export default __webpack_public_path__ + "static/clientwork1-4a27ab4087ffa65160383f4683046c1b.png";